<app-flex
  gap="16px"
  align="center"
  justify="center"
  margin="0 16px"
>
  <div class="switch-to-annual-container">Switch to annual subscription to save</div>
  <div class="reduction-container">20% off</div>
  <mat-slide-toggle
    color="primary"
    [checked]="isAnnualSubscription"
    (change)="toggleAnnualSubscription($event.checked)"
  >
    Annual
  </mat-slide-toggle>
</app-flex>

<app-flex
  gap="16px"
  direction="column"
>
  <app-early-pay-calculator-plan-plate
    [planName]="subscriptionPlans.get(selectedPlan).planName"
    [price]="subscriptionPlans.get(selectedPlan).price"
    [upfrontFee]="subscriptionPlans.get(selectedPlan).upfrontFee"
    [fee]="subscriptionPlans.get(selectedPlan).fee"
    [eppIdealAmount]="subscriptionPlans.get(selectedPlan).eppIdealAmount"
    [selectedPlan]="selectedPlan"
    [isAnnualSubscription]="isAnnualSubscription"
    [arePlansExpanded]="arePlansExpanded"
    (selectSubscriptionPlan)="selectSubscriptionPlan($event)"
    (togglePlansExpanding)="togglePlansExpanding($event)"
  />

  @if (arePlansExpanded) {
    @for (plan of subscriptionPlans.values(); track plan) {
      @if (selectedPlan !== plan.planName) {
        <app-early-pay-calculator-plan-plate
          [planName]="plan.planName"
          [price]="plan.price"
          [fee]="plan.fee"
          [upfrontFee]="plan.upfrontFee"
          [eppIdealAmount]="plan.eppIdealAmount"
          [selectedPlan]="selectedPlan"
          [isAnnualSubscription]="isAnnualSubscription"
          [arePlansExpanded]="arePlansExpanded"
          (selectSubscriptionPlan)="selectSubscriptionPlan($event)"
          (togglePlansExpanding)="togglePlansExpanding($event)"
        />
      }
    }
  }
</app-flex>
